export default __webpack_public_path__ + "static/media/dru__O8A9937_final.6e727be6.jpg";